module.exports = __webpack_public_path__ + "static/media/netlife-logo.88048ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/netlife-logo.png
// module id = 377
// module chunks = 0